export default __webpack_public_path__ + "static/media/querelle_front.45f10614.jpg";